// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manageTranslationsTable__oNKdG {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  display: grid;
  background: var(--tables-title-surface);
  box-shadow: var(--table-box-shadow);
}
.manageTranslationsTable__oNKdG thead {
  display: grid;
  position: relative;
}
.manageTranslationsTable__oNKdG tr {
  box-shadow: none;
  color: inherit;
  vertical-align: middle;
  outline: 0;
  display: flex;
}
.manageTranslationsTable__oNKdG td {
  padding: 14px 15px;
  white-space: normal;
  text-align: left;
  display: flex;
  width: 100%;
  align-items: center;
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
}
.manageTranslationsTable__oNKdG th {
  padding: 14px 15px;
  text-align: left;
  display: flex;
  width: 100%;
  border-top: 1px solid var(--tables-primary-row-stroke);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
.manageTranslationsTable__oNKdG .actionsColumn__Hm4Q1 {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translate(0, -50%);
  width: unset;
  border: unset;
  padding: unset;
}
.manageTranslationsTable__oNKdG .fieldName__ITykh {
  padding-left: 36px;
}
@media (max-width: 1440px) {
  .manageTranslationsTable__oNKdG .rowWithTranslation__IM8zd .fieldName__ITykh {
    max-width: 150px;
  }
  .manageTranslationsTable__oNKdG .rowWithTranslation__IM8zd .originalName__HPdB7 {
    max-width: 200px;
  }
}
@media (max-width: 1024px) {
  .manageTranslationsTable__oNKdG th {
    padding: 10px 10px;
  }
  .manageTranslationsTable__oNKdG td {
    padding: 10px 10px;
  }
  .manageTranslationsTable__oNKdG .rowWithTranslation__IM8zd .fieldName__ITykh {
    padding-left: 26px;
  }
  .manageTranslationsTable__oNKdG .rowWithTranslation__IM8zd .originalName__HPdB7 {
    max-width: 150px;
  }
}

.skeletonTextClassName__SFEcW {
  height: 14px;
}

.sortColumnWrapper__HB2H5 {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sortIcon__lMCQv {
  cursor: pointer;
  outline: none;
}
.sortIcon__lMCQv path {
  fill: var(--tables-title-icon);
}

.activeSort__Kf8A0 path {
  fill: var(--tables-primary-row-icon);
}

.selectLanguageMenuTitle__L1Ybz {
  color: var(--tables-primary-row-stroke-drag-drop);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  position: relative;
  text-align: center;
  outline: 0;
  box-shadow: none;
}

.arrowIcon__gqnKh path {
  stroke: var(--tables-primary-row-stroke-drag-drop);
}

.arrowIconOpen__WwnBZ {
  transform: rotate(180deg);
}

.manageTranslationsTableRow__ZGY_8 {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
}

.name__VUYCL {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
}

.arrowWrapper__zC0Tw {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 5px;
}
.arrowWrapper__zC0Tw .arrowIcon__gqnKh path {
  stroke: var(--tables-secondary-row-sub-title-icon);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTranslations/components/ManageTranslationsTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,uCAAA;EACA,mCAAA;AAzEF;AA2EE;EACE,aAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AA1EJ;AA6EE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA3EJ;AA8EE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,sDAAA;EACA,yDAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5EJ;AA+EE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AA7EJ;AAgFE;EACE,kBAAA;AA9EJ;AAiFE;EAEI;IACE,gBAAA;EAhFN;EAmFI;IACE,gBAAA;EAjFN;AACF;AAqFE;EACE;IACE,kBAAA;EAnFJ;EAsFE;IACE,kBAAA;EApFJ;EAwFI;IACE,kBAAA;EAtFN;EAyFI;IACE,gBAAA;EAvFN;AACF;;AA4FA;EACE,YAAA;AAzFF;;AA4FA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzFF;;AA4FA;EACE,eAAA;EACA,aAAA;AAzFF;AA2FE;EACE,8BAAA;AAzFJ;;AA8FE;EACE,oCAAA;AA3FJ;;AA8FA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AA3FF;;AA+FE;EACE,kDAAA;AA5FJ;;AAgGA;EACE,yBAAA;AA7FF;;AAgGA;EACE,yDAAA;EACA,qDAAA;AA7FF;;AAgGA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA7FF;;AAgGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA7FF;AAgGI;EACE,kDAAA;AA9FN","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.manageTranslationsTable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  display: grid;\n  background: var(--tables-title-surface);\n  box-shadow: var(--table-box-shadow);\n\n  thead {\n    display: grid;\n    position: relative;\n  }\n\n  tr {\n    box-shadow: none;\n    color: inherit;\n    vertical-align: middle;\n    outline: 0;\n    display: flex;\n  }\n\n  td {\n    padding: 14px 15px;\n    white-space: normal;\n    text-align: left;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    color: var(--tables-primary-row-text-main);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 12px;\n    text-transform: uppercase;\n  }\n\n  th {\n    padding: 14px 15px;\n    text-align: left;\n    display: flex;\n    width: 100%;\n    border-top: 1px solid var(--tables-primary-row-stroke);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n  }\n\n  .actionsColumn {\n    position: absolute;\n    right: 25px;\n    top: 50%;\n    transform: translate(0, -50%);\n    width: unset;\n    border: unset;\n    padding: unset;\n  }\n\n  .fieldName {\n    padding-left: 36px;\n  }\n\n  @media (max-width: 1440px) {\n    .rowWithTranslation {\n      .fieldName {\n        max-width: 150px;\n      }\n\n      .originalName {\n        max-width: 200px;\n      }\n    }\n  }\n\n  @media (max-width: 1024px) {\n    th {\n      padding: 10px 10px;\n    }\n\n    td {\n      padding: 10px 10px;\n    }\n\n    .rowWithTranslation {\n      .fieldName {\n        padding-left: 26px;\n      }\n\n      .originalName {\n        max-width: 150px;\n      }\n    }\n  }\n}\n\n.skeletonTextClassName {\n  height: 14px;\n}\n\n.sortColumnWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.sortIcon {\n  cursor: pointer;\n  outline: none;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n.selectLanguageMenuTitle {\n  color: var(--tables-primary-row-stroke-drag-drop);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  cursor: pointer;\n  position: relative;\n  text-align: center;\n  outline: 0;\n  box-shadow: none;\n}\n\n.arrowIcon {\n  path {\n    stroke: var(--tables-primary-row-stroke-drag-drop);\n  }\n}\n\n.arrowIconOpen {\n  transform: rotate(180deg);\n}\n\n.manageTranslationsTableRow {\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n}\n\n.name {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n  text-transform: uppercase;\n}\n\n.arrowWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 5px;\n\n  .arrowIcon {\n    path {\n      stroke: var(--tables-secondary-row-sub-title-icon);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageTranslationsTable": `manageTranslationsTable__oNKdG`,
	"actionsColumn": `actionsColumn__Hm4Q1`,
	"fieldName": `fieldName__ITykh`,
	"rowWithTranslation": `rowWithTranslation__IM8zd`,
	"originalName": `originalName__HPdB7`,
	"skeletonTextClassName": `skeletonTextClassName__SFEcW`,
	"sortColumnWrapper": `sortColumnWrapper__HB2H5`,
	"sortIcon": `sortIcon__lMCQv`,
	"activeSort": `activeSort__Kf8A0`,
	"selectLanguageMenuTitle": `selectLanguageMenuTitle__L1Ybz`,
	"arrowIcon": `arrowIcon__gqnKh`,
	"arrowIconOpen": `arrowIconOpen__WwnBZ`,
	"manageTranslationsTableRow": `manageTranslationsTableRow__ZGY_8`,
	"name": `name__VUYCL`,
	"arrowWrapper": `arrowWrapper__zC0Tw`
};
module.exports = ___CSS_LOADER_EXPORT___;
